import SearchCurrency, { Currency, DepositConfig } from "app/models/currency";

import request from "../request";
import {
  BaseResponse,
  GenericPaginatedResponse,
  GenericResponse,
} from "../types";
import {
  GetCurrenciesParam,
  GetCurrencyOHLCPayload,
  GetCurrencyOHLCResponse,
  GetRecentCurrenciesParam,
  ListPlatformCurrenciesQuery,
  RampFeesPayload,
  SearchCurrenciesParam,
  UpdateDepositConfigPayload,
} from "./types";
import { PLATFORM_URL } from "app/constants/variables";

export const searchCurrencies = (params: SearchCurrenciesParam) => {
  return request.get<GenericPaginatedResponse<SearchCurrency>>(
    "/currency/search",
    {
      params,
    }
  );
};

export const addToWatchList = (asset: string) => {
  return request.put<BaseResponse>(`/currency/${asset}/follow`);
};

export const getCurrency = (id: string) => {
  return request.get<Currency>(`/currency/${id}`);
};

export const getRecentCurrencies = (params: GetRecentCurrenciesParam) => {
  return request.get<GenericPaginatedResponse<Currency>>(`/currency/recent`, {
    params,
  });
};

export const getCurrencies = (params: GetCurrenciesParam) => {
  return request.get<GenericPaginatedResponse<Currency>>("/currency", {
    params,
  });
};

export const getCurrencyOHLC = ({
  symbol,
  ...params
}: GetCurrencyOHLCPayload) => {
  return request.get<GetCurrencyOHLCResponse>(`/currency/ohlc/${symbol}`, {
    params,
  });
};

export const getDepositConfig = () => {
  return request.get<GenericResponse<DepositConfig>>(
    "/deposit/payments-config"
  );
};

export const updateDepositConfig = (payload: UpdateDepositConfigPayload) => {
  return request.put<BaseResponse>(
    `/deposit/payments-config/currencies`,
    payload
  );
};

export const listPlatformCurrencies = (
  params?: ListPlatformCurrenciesQuery
) => {
  return request.get<GenericPaginatedResponse<Currency>>("/currencies", {
    params,
    baseURL: PLATFORM_URL,
  });
};

export const getRampFees = () => {
  return request.get<GenericResponse<RampFeesPayload>>(
    "/deposit/payments-config/fees"
  );
};

export const updateRampFees = (payload: RampFeesPayload) => {
  return request.put("/deposit/payments-config/fees", payload);
};
